<template>
  <div class="swipeHint">
    <Popup :close-on-click-overlay="false" class="popup_box" v-model="isShow">
      <div class="container">
        <div class="popup_content">
          <template v-if="textIndex == 0">
            <div class="popup_content_title">隱私政策</div>
            <div class="popup_content_desc">
              <p>
                最後更新於2024年3月15日
              </p>
              <p>
                這項政策為我們提供了一個數據庫來處理所有弊端
                我們從您那裡收集的個人或您提供的個人
                為了我們。
              </p>
              <p>
                請仔細閱讀下面的內容，以更好地了解視圖
                獲取我們的個人數據處理和處理
                並將處理這些數據。 通過訪問
                網站，您確認您已被理解和接受
                這項政策。 您仍然同意收藏的歷史
                使用，存儲，處理和披露您的個人信息
                如何在本政策中指定。
              </p>
              <p class="popup_content_bold">
                答：我們可以從您那裡收集信息
              </p>
              <p>
                我們可能會收集和處理您的數字
                在下面：
              </p>
              <p>
                i.你向我們提供相關信息
                （發送的信息）可能包括以下信息：
              </p>
              <p>
                全名，地址，電子郵件，電話號碼，年齡，用戶名，親愛的
                其他個人信息和個人信息，財務信息，信用（信用
                包括詳細的銀行帳戶信息和驗證代碼
                銀行（如果有），個人和照片描述）
              </p>
              <p>
                ii。我們收集有關您和您的設備的相關信息
                朋友
              </p>
              <p>
                每次您訪問我們的網站時，我們都有
                可以自動收集有關您使用或
                訪問我們的任何服務網站，包括
                但是沒有限制流量數據，位置數據，
                網絡日記和其他聯繫數據（日記信息）
              </p>
              <p>iii.地址信息</p>
              <p>
                我們還使用GPS技術或其他定位服務
                確認您的位置。 你可以同意你
                與我們一起收集，處理或使用此信息
                通過登錄或停下來訪問我們的網站。
              </p>
              <p>
                iv.我們從其他來源收集信息（附帶信息
                週二）
              </p>
              <p>
                由於我們提供的服務的性質，我們需要
                與許多第三方合作（包括信用諮詢結構，以及
                移動網絡提供商），我們可能會收集這些
                您來自這些各方的相關信息。
              </p>
              <p class="popup_content_bold">B.監視器Cookie</p>
              <p>
                我們可以使用移動跟踪技術或網站
                cookie將您與應用程序的其他用戶區分開
                和其他服務網站。 這有助於我們提供
                當您使用應用程序或訪問時，您會體驗良好
                我們的服務網站，允許我們
                更好地改善您的應用程序和服務網站。
              </p>
              <p class="popup_content_bold">C.如何使用信息</p>
              <p>
                我們可以鏈接任何信息組合
                其他信息列表，將被視為魚類信息的組合
                基於此政策。
              </p>
              <p>
                我們收集的信息將用於驗證供應
                是否向客戶貸款，貸款金額
                以及適用於此的條件和條款
                那是藉來的。
              </p>
              <p>
                我們不會披露個人身份信息
                除了遵守法院的規定外，任何其他方面
                仲裁委員會，法律機構或有意義的案件
                法律案件，其他法律，但我們可以提供
                他們通常有關與他們相關的用戶的一般信息
                我。
              </p>
              <p class="popup_content_bold">D.顯示您的信息</p>
              <p>
                當您訪問和使用我們的服務網站時，
                我們可能會揭示他們的一些或全部數據
                我已經從您那裡聚集到相關的信託機構。
              </p>
              <p>
                我們可能會向聚會透露您的個人信息
                週二：
              </p>
              <p>
                •如果我們出售或購買任何財產或企業
                來吧，在這種情況下，我們可以揭示魚類信息
                您乘以賣方或購買業務潛力。
              </p>
              <p>
                •如果第三方購買了大多數資產或大多數資產
                同樣，在這種情況下，是個人數據吉來
                抱著客戶將是轉移的資產之一
                遞送。
              </p>
              <p>
                •如果我們有義務透露或共享個人數據
                您遵守任何義務或法律要求或
                哪些規定或執行條件條款
                我們和其他協議要么調查微觀行為
                潛在的pham; 向任何錫辦公室報告違規者
                使用哪個； 或發布與歷史有關的統計數據
                申請的應用； 在這些情況下，所有信息將
                合成和匿名。
              </p>

              <p class="popup_content_bold">E.數據存儲和安全性</p>
              <p>
                •我們從您那裡收集的數據可以轉移到和
                存儲在國外或住所以外的地方
                您的（如果有）。 它也可以由員工處理
                在國外工作，您的住所（如果有），
                他們是為我們工作或其中之一的人
                我們的供應商。 這些員工可能會參加
                並在服務網站上滿足您的要求。 經過
                發送您的個人數據，您同意該集合，
                轉移，存儲或處理您的個人數據已經
                如上所述。
              </p>
              <p>
                •如果我們為您提供密碼（或者您選擇
                選擇），因此您可以訪問
                服務網站，您必須對此密碼安全負責。
                我們要求您不要提供任何密碼
                其他人。 有一些事情通過帶來互聯網進行交流
                不完全安全。 我們還將盡力而為
                為了保護您的數據，但我們不能保證
                傳輸到網站時數據的安全性
                我們的服務; 任何傳輸都是由您
                風險。
              </p>
              <p>
                •如果您無法控制密碼，則可以
                失去對個人信息和溝通的重大控制
                您發送給我們的其他新聞。 你也可能被烤
                與執行的法律約束行動有關
                由你。 因此，如果您的密碼出於某種原因被揭示
                或者您有說服密碼的理由已被揭示，
                您應該立即與我們聯繫以更改您的密碼。
              </p>
              <p class="popup_content_bold">F.使用數據</p>
              <p>收集的數據將用於以下目的:</p>
              <p>
                •遵守當前法律，法規，法律程序，
                或詢問政府，包括但不限於原則
                了解您的客戶，客戶評估，反洗
                金錢，反恐怖主義。
              </p>
              <p>•提供和維護服務</p>
              <p>•通知您相關服務更新</p>
              <p>
                •允許您參與服務的互動功能
                我們
              </p>
              <p>•提供客戶服務和支持服務</p>
              <p>
                •提供有價值信息的分析以促進它們
                我改革服務資金
              </p>
              <p>•服務狀態主管</p>
              <p>
                •將您的個人數據用於操作目的，
                營銷和其他廣告。
              </p>
              <p>•檢測和預防技術問題</p>
              <p class="popup_content_bold"> 1.數據傳輸</p>
              <p>
                您的信息（包括個人數據）可能是
                發送到城鎮外，城市，地理位置的計算機
                Phuong，大陸，國家或政府管轄權
                其他，數據保護法可能與該地區法律不同
                您的管轄權。 如果您在台灣外面，然後選擇提供
                為我們提供信息，請注意，我們將傳輸數據
                它是否包括到台灣的個人數據，並將處理數據
                那裡。 您同意本隱私政策，然後
                傳輸相關信息意味著您銅
                意大利這種轉移。 我們將做所有的
                合理的步驟以確保您的數據
                安全並遵守本隱私政策，邪惡
                您的個人是否不會被轉移到任何巢穴
                除非有爭論
                法律控制，包括您的數據安全。
              </p>
              <p class="popup_content_bold">
                2.所需的法律數據
              </p>
              <p>
                我們可能必須成為善意才能在
                所需案例如下：
              </p>
              <p>•法律合規義務</p>
              <p>•保護和防禦我們的權利和財產</p>
              <p>
                •可能發生或調查不當行為
                海關服務
              </p>
              <p>
                •保護服務用戶的人身安全
                銅
              </p>
              <p>•防止責任</p>
              <p class="popup_content_bold"> g。服務提供商</p>
              <p>
                我們可以僱用第三方公司或個人來支持
                我們的翻譯（服務提供商）代表他們
                我提供服務，執行與翻譯有關的服務
                案件或支持我們分析我們的服務
                如何使用。 這些第三方只有訪問權
                代表我們向我們更新您的個人數據
                此任務，不得不披露或使用數據
                出於任何其他目的。
              </p>
              <p class="popup_content_bold"> h。用戶</p>
              <p>
                •我們的服務不是針對18歲以下的人（年輕人
                你）
              </p>
              <p>
                •我們沒有故意收集個人身份信息
                18歲以下的人。 如果您是父母或監護人，並且
                您知道您的孩子向我們提供了魚類信息
                NHAN，請通過電子郵件agnarhalls@gmail.com與我們聯繫。
                如果我們知道我們已經收集了個人數據
                孩子沒有父母的同意，我們會這樣做
                從我們的服務器中刪除該信息的步驟。
              </p>
              <p class="popup_content_bold"> I.您的數據隱私</p>
              <p>
                •修改權：用戶可以將其個人資料傳遞給
                修改，更改名稱，電子郵件地址，密碼和登錄
                動態的
              </p>
              <p>
                •訪問，刪除和限制：用戶可以
                通過agnarhalls@gmail.com與我們聯繫，愛
                祈求訪問或刪除個人信息以及乾旱要求
                處理更多的個人信息。 請等待30
                處理請求的日期。 我們有權收取合適的費用
                處理重複或過多重複要求的原因。
              </p>
              <p>
                •撤回同意的權利：用戶可以停止接收電子郵件
                按照取消註冊的說明，向我們廣告
                在我們發送或通過調整髮送的每封電子郵件中
                個人資料中的營銷選項。 正如剛才提到的，
                用戶可以選擇cookie。 通過修改程序選項
                您的瀏覽，您可以選擇接受所有餅乾，安裝
                餅乾會收到通知或拒絕所有餅乾。
              </p>
              <p>
                •對監督機構抱怨的權利：如果您相信
                您的隱私不受我們的保護
                足夠，您有權向監督機構進行正式投訴
                合身。
              </p>
              <p class="popup_content_bold">
                J.更改本隱私政策
              </p>
              <p>
                我們的隱私政策可以更新
                時間。 我們將告知您任何更改
                通過在本網站上發布新的隱私政策。
                在更改生效之前，我們將通知您
                通過電子郵件或提示，有關該服務的未銷量通知
                我們並在策略開始時更新“有效日期”
                此隱私安全。 您應該審查隱私政策
                這種定期掌握任何更改的周期性。 更改
                有了此政策，它在此頁面上發佈時會生效。
              </p>
              <p class="popup_content_bold">K。如果您有問題</p>
              <p>
                如果您對隱私有任何疑問
                或想發送相關的數據安全要求，請聯繫
                我們的系統通過電子郵件agnarhalls@gmail.com。 請最大化
                30天的處理支持。
              </p>
            </div>
          </template>
          <template v-if="textIndex == 1">
            <div class="popup_content_title">協議協議</div>

            <div class="popup_content_desc">
              <p class="popup_content_bold"> 1.貸款</p>
              <p>
                根據本協議的條款和條件，根據
                黨的要求，貸方同意向借款人提供一些
                VND絕對是“貸款”，借款人同意借方
                上述“貸款”貸款。
              </p>
              <p class="popup_content_bold"> 2.貸款目的地</p>
              <p> 1.貸款用於借款人的個人目的。</p>
              <p>
                2.如上文第2.1條，貸方不負責
                監視或確保使用貸款或部分
                該貸款僅用於第2.1條。 工作
                貸款不符合條例2.1不會影響任何
                貸方的哪些好處有權獲得。
              </p>
              <p class="popup_content_bold"> 3.貸款術語</p>
              <p>
                1.從“錦標賽那天”開始，貸款將在白天截止日期
                貸款“到“貸款期限”結束。
              </p>
              <p>
                2.借款人的提議，貸款期限可以延長
                從到期日起更多的時間（時間限制
                只需跟隨貸方不時決定）。 所以，
                每個成功的擴展名將不得不收取額外費用。 費用
                此擴展名是由貸方規定的，可能會隨著時間而變化
                時間基於貸方的決策和政策。 不喜歡
                告訴上述規定，貸方有權拒絕政策
                借款人的延遲。
              </p>
              <p class="popup_content_bold"> 4。 利率</p>
              <p>
                1.適用於貸款的利率為每年12％的“貸款利率”
                加上第5條規定的服務費（如果有）。
              </p>
              <p>
                2.利息將每天累積在總的主要餘額上
                支付的貸款直到退還貸款
                全額付款。
              </p>
              <p>
                3.根據本國銀行間銀行利率的變化
                台灣宣布貸方有權改變利率
                不時貸款和此更改將被清除
                通過電子郵件，文本，消息通知借款人到地理
                只有借款人已經登記。
              </p>
              <p class="popup_content_bold"> 5。 其他費用</p>
              <p>
                1.借款人將支付貸方的相關費用
                必須收到，其中包括付款費，諮詢費
                瀏覽，程序費。
              </p>
              <p>
                2.如果從借款人到貸款的所有付款
                將考慮高於借款人對貸方的責任
                作為藉款人的預付款（預付款）
              </p>
              <p>
                3.高級付款可以保存在帳戶中
                平台或聯繫相關人員進行退款處理。
              </p>
              <p class="popup_content_bold"> 6。 付款</p>
              <p>
                1.利息一年以360天計算，
                可以在貸款期到期之前支付。
              </p>
              <p>
                2.如果借款人延遲支付利息，借款人將必須付款
                貸方的延遲付款費為10％
                根據本合同的規定。
              </p>
              <p class="popup_content_bold"> 7。 原始債務付款</p>
              <p>
                1.發生違規時，它不會影響請求
                退還貸方的貸款（根據第8條）。 貸款額度
                [原始]將由借款人完全退還
                根據貸款期
              </p>
              <p>
                2.貸款退款將通過轉移來完成
                根據信息到貸款銀行帳戶的條款
                在本合同開始時或貸方描述
                授予。
              </p>
              <p>
                3.借款人有權在到期日之前償還貸款[原始]
                貸款支出之日起什麼時間。 貸款利息和
                其他費用（如果有）將根據實際貸款時間計算。
              </p>
              <p>
                4.根據每次貸方的政策，
                借款人的付款將用於支付
                優先順序如下：
              </p>
              <p> 1。 逾期費； 2.利率； 3.原始貸款</p>
              <p class="popup_content_bold"> 8。 違反合同</p>
              <p> 1。 案件被視為違反合同的行為：</p>
              <p>
                A，如果借款人不向貸方支付錢：
                貸款（本金），貸款利息，諮詢費，服務費，人民
                Gia Han，付款費和/或任何到期日
                其他合同中指定了其他。
              </p>
              <p>
                B，如果借款人違反或顯示違規跡象
                thuan，法規，條款，約束力，條件或承諾
                合同中規定的
              </p>
              <p> c，如果借款人將死亡或失去民事行為。</p>
              <p>
                2.如果發生違規或在此之後的任何時間發生
                發生犯罪，所有未付債務都是相關的
                貸款，包括利息和其他錢（例如，本金，
                當時的利息，逾期利息，費用，佣金等等）
                與該合同相對應的將要到期，必須是
                借款人立即付款，貸方將立即
                要求借款人支付陳述和實施預算的權利
                權利和權力一旦其合法權利就是
                違反本合同的規定和法國的規定。
              </p>
              <p class="popup_content_bold"> 9。 借款人承諾並確認</p>
              <p>
                1.借款人向當事人提供的所有文件和信息
                貸款在各個方面都是真實而準確的，沒有信息
                任何新聞或文件都是隱藏的，假的還是假的。
              </p>
              <p>
                2.在註冊包括性別在內的交易時了解所有風險
                錯誤，安全/隱私，錯誤/假實施中的干旱。
              </p>
              <p>
                3.無條件承諾，不取消所有含義
                貸方根據本協議的案件/責任。
              </p>
              <p class="popup_content_bold">
                10.貸方的權利和義務
              </p>
              <p>
                1.貸方有權決定支出或
                不要向借款人貸款。 批准通知
                支出或支出將發送給借款人
                以下表格之一：電話，消息，電子郵件，
                書面通知或其他形式。
              </p>
              <p>
                2.貸方有權要求借款人支付賠償金
                損壞，責任，索賠，損失，損害，成本
                與雙方之間的交易有關或引起
                此合同。
              </p>
              <p>
                3.貸方有權處理借款人的個人數據，
                必要時向第三方揭示
                貸款。
              </p>
              <p>
                4.貸方負責
                該合同中達成了法律。
              </p>
              <p>
                5.貸方可以自己或授權第三方愛
                根據規定的合同傳播。
              </p>
              <p class="popup_content_bold">
                11.借款人的權利和義務
              </p>
              <p>
                1.借款人有權要求貸款支付貸款
                根據之前提議的時間表。
              </p>
              <p>
                2.借款人負責實現和準時的含義
                的情況下
              </p>
              <p>我符合這份合同。</p>
              <p>
                3.借用無條件借來的，不取消
                貸款人的責任和賠償
                投訴，損失成本，損失，損害和成本
                雙方之間的交易引起的其他相關或引起的
                根據本協議。
              </p>
              <p class="popup_content_bold"> 12。 法律和權威</p>
              <p>
                1.該協議將根據法語進行調整和解釋
                台灣法律。
              </p>
              <p>
                2.在發生爭議，失敗和矛盾的情況下
                違反了出現或與解釋有關的各方
                或履行此合同，各方將解決爭議
                通過在30（30）天內談判調解
                從第一天起，一方將通知發送給另一方有關爭議的信息。
                在沒有談判的情況下，爭議將是法院
                台灣的管轄權已解決。
              </p>
              <p class="popup_content_bold"> 13。 效果</p>
              <p>
                1.這裡的各方承認並同意不取消協議
                這有利
              </p>
              <p>
                2.在台灣法律的允許範圍內，本合同
                從簽署之日起生效，並為當事方具有約束力價值
                直到雙方之間的貸款關係結束。
              </p>
              <p>
                3.始終，如果本合同的任何條款
                或由於法規而變得無效或無法實施
                任何其他司法管轄區，價值觀和差異的法律
                法律力量和其餘條款的實施不是照片
                享受任何形式。
              </p>
            </div>
          </template>
        </div>
        <div class="popup_close" @click="closePopup">關閉</div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { Popup } from "vant";
export default {
  name: "swipeHint",
  components: { Popup },
  props: {
    boxIndex: {
      type: [String, Number],
      default: "0",
    },
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      isShow: this.show,
      texts: [
        require("@/assets/home/popup1.png"),
        require("@/assets/home/popup2.png"),
        require("@/assets/home/popup3.png"),
      ],
      textIndex: 0,
    };
  },
  watch: {
    show(newVal) {
      this.isShow = newVal;
    },
    boxIndex(newVal) {
      this.textIndex = newVal;

      if(this.$store.state.user.isNested){
        this.textIndex = 2;
      }
    },
  },
  created() {
    if(this.$store.state.user.isNested){
      this.textIndex = 2;
    }
  },
  methods: {
    closePopup() {
      this.isShow = false;
      this.$emit("closePopup");
    },
  },
};
</script>

<style lang="less" scoped>
.swipeHint {
  /deep/ .van-overlay {
    background: rgba(101, 101, 101, 0.2);
    backdrop-filter: blur(3px);
  }
}
.popup_box {
  width: calc(100% - 30px);
  height: 534px;
  border-radius: 11px;
  box-sizing: border-box;
  background: none;
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    background: #ffffff;
    // overflow: auto;
    border-radius: 20px;
    .popup_content {
      padding: 20px 10px;
      box-sizing: border-box;
      overflow: auto;
      height: 451px;
      .popup_content_title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        text-align: center;
        color: #333333;
        letter-spacing: 1px;
      }
      .popup_content_desc {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        .popup_content_bold {
          margin-top: 20px;

          font-size: 14px;
          font-weight: 500;
        }
        // p {
        //   margin: 6px 0;
        // }
      }
    }
  }
  .popup_close {
    margin: 20px auto;
    width: 138px;
    height: 43px;
    background: #EF9614;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    letter-spacing: 1px;
  }
}
</style>
